import React from 'react';
import { useNavigate } from 'react-router-dom';

// End-of-page link back to the case study carousel on the home page, so
// readers have a way out even while the header is hidden.
function CaseStudyBackLink() {
  const navigate = useNavigate();

  const handleClick = (event) => {
    event.preventDefault();
    navigate('/');
    // Wait for the home page to mount before scrolling to the carousel
    setTimeout(() => {
      const carousel = document.getElementById('carousel_section');
      if (carousel) {
        carousel.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="case-study-back">
      <div className="container">
        <a className="button-tertiary" href="/#carousel_section" onClick={handleClick}>
          <span className="material-icons button-tertiary__icon button-tertiary__icon--back" aria-hidden="true">arrow_back</span>
          Back to case studies
        </a>
      </div>
    </div>
  );
}

export default CaseStudyBackLink;
